const STORAGE_KEY = 'createActivityDraft';
const DEBOUNCE_MS = 400;
const DRAFT_VERSION = 1;
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

let saveTimer = null;

function writeDraft(payload) {
  try {
    const toStore = {
      version: DRAFT_VERSION,
      updatedAt: Date.now(),
      ...payload,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
  } catch (err) {
    console.warn('Failed to save create activity draft:', err);
  }
}

export function saveCreateActivityDraftDebounced(payload) {
  if (saveTimer) clearTimeout(saveTimer);
  saveTimer = setTimeout(() => {
    saveTimer = null;
    writeDraft(payload);
  }, DEBOUNCE_MS);
}

export function flushCreateActivityDraft(payload) {
  if (saveTimer) {
    clearTimeout(saveTimer);
    saveTimer = null;
  }
  if (payload) {
    writeDraft(payload);
  }
}

export function getCreateActivityDraft() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const draft = JSON.parse(raw);
    if (!draft || draft.version !== DRAFT_VERSION) return null;
    if (draft.updatedAt && Date.now() - draft.updatedAt > TTL_MS) {
      clearCreateActivityDraft();
      return null;
    }
    return draft;
  } catch (err) {
    console.warn('Failed to read create activity draft:', err);
    return null;
  }
}

export function clearCreateActivityDraft() {
  if (saveTimer) {
    clearTimeout(saveTimer);
    saveTimer = null;
  }
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn('Failed to clear create activity draft:', err);
  }
}

function hasMeaningfulContent(draft) {
  if (!draft) return false;
  const name = draft.formData?.name || draft.quickFormData?.name;
  if (name && String(name).trim()) return true;
  const locationUrl =
    draft.optionalLocationUrl ||
    draft.quickFormData?.location_url ||
    draft.formData?.location_url;
  if (locationUrl && String(locationUrl).trim()) return true;
  const locationTitle =
    draft.optionalLocationTitle ||
    draft.quickFormData?.location_title ||
    draft.formData?.location_title;
  if (locationTitle && String(locationTitle).trim()) return true;
  if (draft.currentStep && draft.currentStep !== 'name') return true;
  return false;
}

export function hasActiveCreateActivityDraft() {
  const draft = getCreateActivityDraft();
  if (!draft) return false;
  if (draft.currentStep === 'success') return false;
  return hasMeaningfulContent(draft);
}

/** Strip non-serializable fields from quick form before save. */
export function sanitizeQuickFormData(quickFormData) {
  if (!quickFormData) return quickFormData;
  const { descriptionImage, descriptionImagePreview, ...rest } = quickFormData;
  return rest;
}
